import { render, staticRenderFns } from "./parkingAreaDetail.vue?vue&type=template&id=73a43bbc"
import script from "./parkingAreaDetail.vue?vue&type=script&lang=js"
export * from "./parkingAreaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports